import _classCallCheck from "/var/www/web-feedback/form-builder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/var/www/web-feedback/form-builder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/web-feedback/form-builder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/www/web-feedback/form-builder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/var/www/web-feedback/form-builder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /*#__PURE__*/function (_Error) {
  _inherits(SentryError, _Error);
  function SentryError(message) {
    var _this;
    var logLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warn';
    _classCallCheck(this, SentryError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SentryError).call(this, message));
    _this.message = message;
    _this.logLevel = logLevel;
    return _this;
  }
  return SentryError;
}(_wrapNativeSuper(Error));
export { SentryError };